module.exports = __webpack_public_path__ + "img/sol_cap3.24a765c3.png";